// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"429":"ee504c48","509":"9aac11f2","590":"af36655d"}[chunkId] + ".chunk.css";
};